import styled from 'styled-components';

const StepBadge = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  border-radius: 8px;
  background: #FF9704;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
  color: #131315;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
`;

const StepHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 30px;
`;

const OfferBlock = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  min-height: 125px;

  @media (max-width: 768px) {
    min-height: auto;
  }
`;

const ItemList = styled.ul`
  margin: 0;
  padding-left: 20px;

  ::marker {
    color: #AFAFAF; 
  }
`;

export { StepBadge,StepHeader,OfferBlock,ItemList }